import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import common from 'src/js/modules/common/';

const { InteractiveBox, SelectedIcon, Tag } = designSystem;
const {
  components: { ModalWithPanels },
} = common;

const MODAL_WIDTH = 336;
const MODAL_HEIGHT = 552;

const TextDecorationLibraryDialog = ({
  decorations,
  activeDecorationRef,
  activeDecorationId,
  initialDecorationId,
  dialogPosition,
  captions,
  premiumAvailable,
  onDecorationChange,
  onSubmit,
  onCancel,
  onDialogReady,
  onOverlayClick,
  onDialogDragEnd,
}) => (
  <ModalWithPanels
    width={MODAL_WIDTH}
    height={MODAL_HEIGHT}
    offsetX={dialogPosition?.x}
    offsetY={dialogPosition?.y}
    captions={captions}
    onSubmit={onSubmit}
    onCancel={onCancel}
    onReady={onDialogReady}
    onOverlayClick={onOverlayClick}
    onDragEnd={onDialogDragEnd}
    onPressEsc={onCancel}
  >
    <div className="ws-text-decoration-library">
      {decorations.map(({ id, previewUrl, premium }) => (
        <InteractiveBox
          key={id}
          borderRadius="small"
          selected={activeDecorationId === id}
          focusable={activeDecorationId !== id}
          onClick={() => onDecorationChange(id, premium)}
        >
          <div
            className="ws-text-decoration-library__item-box"
            {...(activeDecorationId === id && { ref: activeDecorationRef })}
          >
            <img className="ws-text-decoration-library__item-preview" src={previewUrl} alt={id} />
            {activeDecorationId === id && (
              <div className="ws-text-decoration-library__item-selected-badge">
                <SelectedIcon />
              </div>
            )}
            {!premiumAvailable &&
              premium &&
              activeDecorationId !== id &&
              initialDecorationId !== id && (
                <div className="ws-text-decoration-library__item-premium-badge">
                  <Tag appearance="cta" iconGlyph="star" size="small" />
                </div>
              )}
          </div>
        </InteractiveBox>
      ))}
    </div>
  </ModalWithPanels>
);

TextDecorationLibraryDialog.propTypes = {
  decorations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      previewUrl: PropTypes.string.isRequired,
      premium: PropTypes.bool,
    })
  ).isRequired,
  activeDecorationRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  activeDecorationId: PropTypes.string.isRequired,
  initialDecorationId: PropTypes.string.isRequired,
  dialogPosition: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    submitButton: PropTypes.string.isRequired,
    cancelButton: PropTypes.string.isRequired,
  }).isRequired,
  premiumAvailable: PropTypes.bool.isRequired,
  onDecorationChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDialogReady: PropTypes.func.isRequired,
  onOverlayClick: PropTypes.func.isRequired,
  onDialogDragEnd: PropTypes.func.isRequired,
};

export default TextDecorationLibraryDialog;
